import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { unstableSetRender } from 'antd';

dayjs.locale('zh-cn');
import { AuthProvider } from './components/Layout/AuthContext';

unstableSetRender((node, container) => {
  const anyContainer = container as unknown as { __antdRoot?: ReturnType<typeof ReactDOM.createRoot> };
  const root = anyContainer.__antdRoot ?? ReactDOM.createRoot(container);
  anyContainer.__antdRoot = root;
  root.render(node);
  return async () => {
    root.unmount();
    delete anyContainer.__antdRoot;
  };
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
